import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/demand/owners')({
  component: Outlet,
});
